import { daysFromTodayToDateString, getDateOnly } from '@jbhi-fi/utils/src/date';
import {
  CompetitionGridFilter,
  CompetitionStatusGridProps,
} from '@jbhi-fi/components/src/CompetitionStatusGrid/CompetitionStatusGrid';
import { ContentfulCompetitionGrid } from '@jbhi-fi/apis/src/contentful/types';

export abstract class CompetitionGridTransformer {
  static toCompetitionStatusGridProps = (entry: ContentfulCompetitionGrid): CompetitionStatusGridProps => ({
    filter: entry.fields ? getFilter(entry) : {},
  });
}

const getFilter = (entry: ContentfulCompetitionGrid): CompetitionGridFilter => {
  const { fields } = entry;
  const currentDateTime = new Date();
  const currentDate = getDateOnly(currentDateTime);

  const filter: CompetitionGridFilter = {};

  if (fields?.openedOrClosed) {
    filter['fields.endDate[gte]'] = currentDate;

    if (fields.closingInXDays) {
      filter['fields.endDate[lte]'] = daysFromTodayToDateString(fields.closingInXDays);
    }
  } else {
    filter['fields.endDate[lt]'] = currentDate;

    if (fields?.closedWithinXDaysAgo) {
      filter['fields.endDate[gte]'] = daysFromTodayToDateString(-fields.closedWithinXDaysAgo);
    }
  }

  if (fields?.parentPage.sys.contentType.sys.id === 'subLandingPage') {
    filter['fields.parentPage.sys.id'] = fields.parentPage.sys.id;
  }

  if (fields?.parentPage.sys.contentType.sys.id === 'landingPage') {
    filter['fields.parentPage.sys.contentType.sys.id'] = 'subLandingPage';
    filter['fields.parentPage.fields.categoryPage.sys.id'] = fields.parentPage.sys.id;
  }

  return filter;
};
